import 'core-js/stable'
import i18next from 'i18next'
import React from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import './index.css'
import { ConfigureStore } from './redux/configureStore'
import reportWebVitals from './reportWebVitals'
import carousel_ar from './translations/ar/carousel.json'
import common_ar from './translations/ar/common.json'
import header_ar from './translations/ar/header.json'
import months_ar from './translations/ar/months.json'
import validation_ar from './translations/ar/validation.json'
import welcome_ar from './translations/ar/welcome.json'
import { defaultLanguage } from './translations/constant/index'
import carousel_en from './translations/en/carousel.json'
import common_en from './translations/en/common.json'
import header_en from './translations/en/header.json'
import months_en from './translations/en/months.json'
import validation_en from './translations/en/validation.json'
import welcome_en from './translations/en/welcome.json'

const { store, persistor } = ConfigureStore()

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: !!localStorage.getItem('lang')
    ? localStorage.getItem('lang').toLocaleLowerCase()
    : defaultLanguage.toLocaleLowerCase(), // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
      validation: validation_en,
      carousel: carousel_en,
      welcome: welcome_en,
      header: header_en,
      months: months_en,
    },
    ar: {
      common: common_ar,
      validation: validation_ar,
      carousel: carousel_ar,
      welcome: welcome_ar,
      header: header_ar,
      months: months_ar,
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
